// src/context/CartContext.jsx
import { createContext, useContext, useState } from "react";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartRefresh, setCartRefresh] = useState(false);

  const triggerCartRefresh = () => {
    setCartRefresh((prev) => !prev);
  };

  return (
    <CartContext.Provider value={{ cartRefresh, triggerCartRefresh }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
